<template>
  <div class="table-box">
    <!--查询-->
    <div class="search-box">
      <div class="search-left">
        <div>
          <span>项目名称:</span>
          <el-input
            class="search-input"
            placeholder="项目名称"
            v-model="searchQuery.projectName"
            clearable
          ></el-input>
        </div>
        <div>
          <span>任务月度:</span>
          <el-date-picker
            @change="dateChange"
            range-separator="-"
            value-format="yyyy-MM"
            type="month"
            v-model="searchQuery.taskDt"
          ></el-date-picker>
        </div>
        <div>
          <span>订单编号:</span>
          <el-input
            class="search-input"
            placeholder="订单编号"
            v-model="searchQuery.orderNo"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="search-right">
        <el-button type="primary" @click="searchEvent">查询</el-button>
        <!-- 二级灵工服务和三级灵公服务（工业-薪未来-C）显示下载按钮 -->
        <el-button
          type="primary"
          style="background:#EB8E0E;border:1px solid #EB8E0E;"
          @click="showTaxReturnDialog()"
          v-if="searchQuery.businessType == 6 || searchQuery.patternType == 7"
        >
          下载纳税申报表
        </el-button>
      </div>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
        header-row-class-name="noBorder"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="序号"
          width="50"
          type="index"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="orderNo"
          type="expand"
        >
          <template slot-scope="{ row }">
            <div class="expandBox">
              <p>项目订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.orderNo }}</p>
              </div>
              <div class="orderNo">
                <p>项目金额：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ (row.projectPrice - row.discountPrice) | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('payDetail', 3, row)"
                  >
                    详情
                  </el-button>
                  <el-popover
                    placement="top-start"
                    trigger="hover"
                    v-if="
                      searchQuery.projectStructureType == 1 && row.discountPrice
                    "
                  >
                    <div>
                      应付：{{
                        (row.initOrderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                    <div>
                      实付：{{
                        (row.orderPrice - row.platformServicesPrice)
                          | moneyFixed
                      }}
                    </div>
                    <img
                      src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                      slot="reference"
                      class="info"
                    />
                  </el-popover>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>{{ row.payStatus | transStatus }}</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>{{ row.orderPayDt | transAllTime }}</p>
              </div>
              <div style="display:flex;flex-direction:row">
                <el-button
                  primary
                  type="text"
                  @click="showComponent('confirmPay', 3, row)"
                >
                  详情
                </el-button>
                <el-button
                  type="text"
                  @click="goPayDetail(row)"
                  v-if="searchQuery.projectStructureType === 3"
                >
                  支付详情下载
                </el-button>
              </div>
            </div>
            <div class="expandBox">
              <p>平台服务费订单</p>
              <div class="orderNo">
                <p>订单编号：</p>
                <p>{{ row.serviceOrderNo }}</p>
              </div>
              <div class="orderNo">
                <p>平台服务费：</p>
                <div style="display:flex;align-items:center;">
                  <span style="margin-right:10px;">
                    {{ row.platformServicesPrice | moneyFixed }}
                  </span>
                  <el-button
                    primary
                    type="text"
                    style="padding:0;"
                    @click="showComponent('serviceDetail', null, row)"
                  >
                    详情
                  </el-button>
                </div>
              </div>
              <div>
                <p>支付状态：</p>
                <p>{{ row.servicesPricePayStatus | serviceStatus }}</p>
              </div>
              <div class="orderNo">
                <p>支付时间：</p>
                <p>{{ row.servicePayDt | transAllTime }}</p>
              </div>
              <el-button
                primary
                type="text"
                @click="showComponent('servicePay', 2, row)"
              >
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="projectName"
          label="项目名称"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="任务月度"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="订单生成时间"
          v-if="searchQuery.projectStructureType == 1"
          key="taskDt"
        >
          <template slot-scope="{ row }">
            {{ row.createDt | transDate }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="本次需打款总金额"
          width="120"
        >
          <template slot-scope="{ row }">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ row.orderPrice | moneyFixed }}</span>
              <el-popover
                placement="top-start"
                trigger="hover"
                v-if="
                  searchQuery.projectStructureType === 1 && row.discountPrice
                "
              >
                <div>应付：{{ row.initOrderPrice | moneyFixed }}</div>
                <div>优惠：{{ row.discountPrice | moneyFixed }}</div>
                <div>实付：{{ row.orderPrice | moneyFixed }}</div>
                <img
                  src="http://cdn.yxvzb.com/WEB/SaaS/images/coupon.svg"
                  slot="reference"
                  class="info"
                />
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              style="display:flex;justify-content:space-around;align-items:center;"
            >
              <span>{{ scope.row.payStatus | transStatus }}</span>
              <el-button
                type="text"
                @click="showComponent('confirmPay', 1, scope.row)"
              >
                详情
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <component
      :is="componentName"
      :show-dialog="showDetail"
      :activeTask="activeTask"
      :type="type"
    ></component>
    <pay-detail></pay-detail>
  </div>
</template>

<script>
import taxReturn from './taxReturn.vue';
import payDetail from './payDetail.vue';
import qualifyDetail from './qualifyDetail.vue';
import serviceDetail from './serviceDetail.vue';
import getiDetail from './getiDetail.vue';
import gerenDetail from './gerenDetail.vue';
import confirmPay from './confirmPay.vue';
import {
  projectOrderCompleteList,
  alreadyDownBack,
  projectV2
} from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect';
import datePicker from '@/Mixin/datePicker';
import { projectOrderPayStatus } from '@/config/staticData';
import sanjiConfirmPay from './sanjiConfirmPay.vue';
import sanji from '@/Mixin/sanji';
import dingdanFillProjectName from '@/Mixin/dingdanFillProjectName';
export default {
  mixins: [pageInation, makeSure, datePicker, sanji, dingdanFillProjectName],
  props: {
    chooseType: {
      type: Number
    }
  },
  data() {
    return {
      projectOrderPayStatus,
      ruleForm: {
        taskDate: ''
      },
      getList: projectOrderCompleteList, // 获取列表的AJAX
      searchQuery: {
        hasPay: 1,
        projectName: '',
        supplieName: '',
        orderNo: '',
        payStatus: '',
        taskDt: '',
        projectStructureType: ''
      },
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      showDetail: false,
      componentName: '',
      activeTask: 'projectPay',
      item: {
        data: null
      },
      type: ''
    };
  },
  components: {
    dicSelect,
    payDetail,
    qualifyDetail,
    serviceDetail,
    confirmPay,
    getiDetail,
    gerenDetail,
    sanjiConfirmPay,
    taxReturn
  },
  provide() {
    return {
      itemData: this.item
    };
  },
  watch: {
    chooseType: {
      handler() {
        this.dealThreeFlex();
        this.initWatchRouteChange();
      }
    }
  },
  methods: {
    goPayDetail(row) {
      //支付详情
      let queryString = this.$querystring.stringify({
        ...this.searchQuery,
        id: row.id,
        projectId: row.projectId
      });
      window.open(
        projectV2.exportThreeLevelProjectPayListDetail + '?' + queryString
      );
    },
    searvicePayHandler(payStatus) {
      if ([0, 3].includes(payStatus)) {
        return '支付';
      } else if (payStatus == 1) {
        return '支付中';
      } else {
        return '支付成功';
      }
    },
    showComponent(componentName, type = null, item = null) {
      item.projectStructureType = this.searchQuery.projectStructureType;
      this.item.data = item;
      if (componentName == 'payDetail') {
        if (this.searchQuery.projectStructureType == 1) {
          //四级
          this.componentName = 'payDetail';
        } else if (this.searchQuery.projectStructureType == 2) {
          //三级个体
          this.componentName = 'getiDetail';
        } else {
          //三级个人
          this.componentName = 'gerenDetail';
        }
      } else if (componentName == 'confirmPay') {
        this.type = type;
        this.componentName =
          this.searchQuery.projectStructureType > 1
            ? 'sanjiConfirmPay'
            : 'confirmPay';
      } else if (componentName == 'servicePay') {
        //服务费处支付
        this.type = 2;
        this.componentName =
          this.searchQuery.projectStructureType > 1
            ? 'sanjiConfirmPay'
            : 'confirmPay';
      } else {
        //其他
        this.componentName = componentName;
      }
      localStorage.setItem('activeTask', JSON.stringify(item));
      this.showDetail = true;
    },
    showTaxReturnDialog() {
      this.componentName = 'taxReturn';
      this.showDetail = true;
      if (this.searchQuery.patternType == 7) {
        // 三级灵工（工业-薪未来-C）
        this.type = 1;
      } else {
        this.type = 2;
      }
    },
    downloadFile(row) {
      let { orderNo, projectName } = row;
      window.open(
        `${alreadyDownBack}?payOrderNo=${orderNo}&projectName=${projectName}`
      );
    },
    dealThreeFlex() {
      if (/threeFlex/.test(this.$route.path)) {
        if (this.chooseType === 1) {
          this.searchQuery.projectStructureType = 3;
          this.searchQuery.patternType = 7;
          this.isIndustry = true;
          this.isP = false;
        } else if (this.chooseType === 2) {
          this.searchQuery.projectStructureType = 1;
          this.searchQuery.patternType = 8;
          this.isIndustry = false;
          this.isP = true;
        }
      }
    }
  },
  filters: {
    transStatus(v) {
      let s = {
        1: '待支付',
        2: '支付中',
        3: '支付未通过',
        4: '部分支付成功',
        5: '支付成功'
      };
      return s[v];
    },
    serviceStatus(v) {
      let s = {
        0: '待支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  },
  created() {
    if (this.$route.query.orderNo) {
      this.searchQuery.orderNo = this.$route.query.orderNo;
      this.searchQuery.taskDt = '';
    }
    this.dealThreeFlex();
  }
};
</script>
<style lang="scss" scoped>
.info {
  width: 14px;
  height: 14px;
  margin-top: -4px;
}
</style>
